// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "pmf-app-991f9.firebaseapp.com",
  "projectId": "pmf-app-991f9",
  "storageBucket": "pmf-app-991f9.appspot.com",
  "messagingSenderId": "219729021826",
  "appId": "1:219729021826:web:5a212ad595e0614a1c9d9b",
  "measurementId": "G-45BPHWMY5F",
  "apiKey": "AIzaSyDV8F-2OqmoZc_0depHNzPxg3_7oSYzlkc"
};
